import { render, staticRenderFns } from "./commodityFrame.vue?vue&type=template&id=cb18ed06"
import script from "./commodityFrame.vue?vue&type=script&lang=js"
export * from "./commodityFrame.vue?vue&type=script&lang=js"
import style0 from "./commodityFrame.vue?vue&type=style&index=0&id=cb18ed06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports